'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAV_CONTENT = exports.NAV_CONTENT = [{
  label: 'Login',
  url: '/my-upds/secure/index.html'
}, {
  label: 'Suppliers',
  url: '/suppliers.html'
}, {
  label: 'Contact Us',
  url: '/contact-us.html'
}, {
  label: 'About Us',
  url: '/about-us.html'
},
//  {
//    label: 'News & Events',
//    url: '/news.html'
//  },
{
  label: 'Transload Advantage',
  url: '/transload-advantage.html'
}, {
  label: 'Our Solutions',
  url: '/our-solutions.html'
}];


// WEBPACK FOOTER //
// ./src/app/shared/constants/nav-content.js